import { atom } from "jotai";

import { DiningBookingWizardDataAtom } from "@/features/BookingWizard/DiningBookingWizard/atoms/stores";

export const getDiningOccasionTags = atom((get) => {
  const diningData = get(DiningBookingWizardDataAtom);
  return diningData?.occasionTags ?? [];
});
